module.exports = __webpack_public_path__ + "img/noun-house-1076883.052aebd0.svg";